import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import * as reportGeneration from '../../../../../redux/reportGeneration';
import type { ReportCategory, ReportExclusionOptions } from '../../shared/types';
import type { DependencyMetadataFilterOption, FormatName, IncludeFilterOption, IncludeFixPlanFilterOption } from '../shared/types';
import type { Revision } from '../../../../../../shared/model-typings';
import ProjectActionButtons from './ProjectActionButtons';
import ProjectGroupActionButtons from './ProjectGroupActionButtons';

type Props = {
  isDisabled?: boolean;
  reportType: ReportCategory;
  format: FormatName | null;
  includeOptions: IncludeFilterOption[];
  dependencyMetadataOptions: DependencyMetadataFilterOption[];
  fixPlanOptions: IncludeFixPlanFilterOption[];
  revision?: Revision;
  authorName?: string;
  authorEmail?: string;
  supplier?: string;
  excludeOptions?: ReportExclusionOptions;
};

const ActionButtons: VoidFunctionComponent<Props> = ({
  format,
  reportType,
  includeOptions,
  dependencyMetadataOptions,
  fixPlanOptions,
  isDisabled,
  revision,
  authorName,
  authorEmail,
  supplier,
  excludeOptions,
}: Props) => {
  const projectType = useSelector(reportGeneration.selectors.getProjectType);

  return projectType === 'project' ? (
    <ProjectActionButtons
      format={format}
      reportType={reportType}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
      fixPlanOptions={fixPlanOptions}
      isDisabled={isDisabled}
      revision={revision}
      authorName={authorName}
      authorEmail={authorEmail}
      supplier={supplier}
      excludeOptions={excludeOptions}
    />
  ) : (
    <ProjectGroupActionButtons
      format={format}
      reportType={reportType}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
      fixPlanOptions={fixPlanOptions}
      isDisabled={isDisabled}
      authorName={authorName}
      authorEmail={authorEmail}
      supplier={supplier} />
  );
};

export default ActionButtons;
